import "./about.css";
import SocialContact from "../../common/social-contact/index";
import HeroBanner from "../../../assets/coding.png";
function About() {
  return (
    <div className="about">
      <div className="about-card">
        <div className="about-content">
          <div className="about-info">
            <div className="about-greeting">Hi ✋, I am</div>
            <div className="about-name">Nikhil Gupta</div>
            <div className="about-title">
              Senior Software Engineer — Full Stack & AI Platforms
            </div>
            <div className="about-description">
              Senior software engineer with 5+ years of experience building
              enterprise-grade, full-stack applications and AI-powered products.
              I design scalable architectures and integrate LLMs, RAG, and agent
              workflows to deliver intelligent, reliable solutions at scale.
            </div>
            <div className="about-resume-section">
              <a
                href="https://drive.google.com/file/d/1nLwYtYj8vYpuMLNG-AAaZZ-yoZ__9HV3/view?usp=drive_link"
                target="_blank"
                rel="noreferrer"
                className="resume-link"
              >
                <span className="resume-text">View Resume</span>
                <span className="resume-icon">📄</span>
              </a>
            </div>
          </div>
          <div className="about-image">
            <img
              alt="Nikhil Gupta - Senior Software Engineer"
              src={HeroBanner}
              className="profile-image"
              height={300}
              width={300}
              rel="preload"
            />
          </div>
        </div>
      </div>
      <SocialContact />
    </div>
  );
}

export default About;
